export const T = {
  en_GB: {
    dialogDescription: "Full details of this order.",
    instrument: "Instrument",
    isin: "ISIN",
    ticker: "Ticker",
    mode: "Order mode",
    modeAmount: "Amount",
    modeUnits: "Units",
    order: "Order",
    type: "Type",
    targetAmount: "Target amount",
    targetUnits: "Target units",
    targetWeight: "Target weight",
    executedAmount: "Executed amount",
    executedUnits: "Executed units",
    price: "Price per unit",
    estimatedShort: "est.",
    currency: "Currency",
    accountRouting: "Account & routing",
    wrapperType: "Wrapper type",
    switchFrom: (product: string) => `Switch from ${product}`,
    accountExternalId: "Account external ID",
    supportedWrapperTypes: "Supported wrapper types",
    externalOrderId: "External order ID",
    lifecycle: "Lifecycle",
    status: "Status",
    statusReason: "Status reason",
    createdAt: "Created",
    submittedAt: "Submitted",
    executedAt: "Executed",
    copy: "Copy",
    statusLabels: {
      pending: "Pending",
      submitted: "Submitted",
      executed: "Executed",
      partially_executed: "Partial",
      failed: "Failed",
      cancelled: "Cancelled",
      modified: "Modified",
    },
    // QL-283 — switch orders
    sellSide: "Sell side (source)",
    buySide: "Buy side (target)",
    switchInstruction: "Instruction",
    switchPercentOf: (percent: string) => `${percent}% of the position`,
    switchUnitsOf: (units: string) => `${units} units of the position`,
    estimatedProceeds: "Estimated proceeds",
    proceedsInvested: "Proceeds invested",
    switchRestingNote:
      "The bank is completing the buy side — a partially executed switch may rest for several days while it retries.",
  },
  nb_NO: {
    dialogDescription: "Alle detaljer for denne ordren.",
    instrument: "Instrument",
    isin: "ISIN",
    ticker: "Ticker",
    mode: "Ordremodus",
    modeAmount: "Beløp",
    modeUnits: "Andeler",
    order: "Ordre",
    type: "Type",
    targetAmount: "Målbeløp",
    targetUnits: "Målandeler",
    targetWeight: "Målvekt",
    executedAmount: "Utført beløp",
    executedUnits: "Utførte andeler",
    price: "Pris per andel",
    estimatedShort: "ca.",
    currency: "Valuta",
    accountRouting: "Konto og ruting",
    wrapperType: "Innpakningstype",
    switchFrom: (product: string) => `Bytte fra ${product}`,
    accountExternalId: "Ekstern konto-ID",
    supportedWrapperTypes: "Støttede innpakningstyper",
    externalOrderId: "Ekstern ordre-ID",
    lifecycle: "Livssyklus",
    status: "Status",
    statusReason: "Statusårsak",
    createdAt: "Opprettet",
    submittedAt: "Sendt",
    executedAt: "Utført",
    copy: "Kopier",
    statusLabels: {
      pending: "Ventende",
      submitted: "Sendt",
      executed: "Utført",
      partially_executed: "Delvis",
      failed: "Feilet",
      cancelled: "Kansellert",
      modified: "Endret",
    },
    // QL-283 — bytteordrer
    sellSide: "Salgsside (kilde)",
    buySide: "Kjøpsside (mål)",
    switchInstruction: "Instruksjon",
    switchPercentOf: (percent: string) => `${percent}% av posisjonen`,
    switchUnitsOf: (units: string) => `${units} andeler av posisjonen`,
    estimatedProceeds: "Estimert proveny",
    proceedsInvested: "Proveny investert",
    switchRestingNote:
      "Banken fullfører kjøpssiden — et delvis utført bytte kan hvile i flere dager mens den prøver på nytt.",
  },
} as const;
